import { StatesModule } from '@uirouter/angular';
import { Transition } from '@uirouter/core';

import { CanAccessAppsService } from '../auth/services/can-access-apps.service';
import { LocationHelperService } from '../shared/services/location-helper.service';
import { ViewportComponent } from './viewport/viewport.component';

export const routes: StatesModule = {
  states: [
    {
      name: 'apps',
      url: '?cid',
      params: {
        cid: {
          dynamic: true,
        },
      },
      abstract: true,
      component: ViewportComponent,
      data: {
        requiresAuth: true,
      },
    },
    {
      name: 'apps.home',
      url: '/',
      redirectTo: 'apps.editor.home',
    },
    {
      name: 'apps.auth.signup',
      url: '/signup',
      resolve: [
        {
          token: 'authenticate',
          deps: [Transition, CanAccessAppsService, LocationHelperService],
          resolveFn: (
            transition,
            canAccessAppsService: CanAccessAppsService,
            locationHelperService,
          ) => {
            const showProduct =
              locationHelperService.getSearchParam('show_product');

            return canAccessAppsService.canAccessApps(true).then(() => {
              transition.abort();
              if (showProduct) {
                return transition.router.stateService.go('apps.purchase.plans');
              } else {
                return transition.router.stateService.go('apps.home');
              }
            });
          },
        },
      ],
    },
    {
      name: 'apps.auth.signin',
      url: '/signin',
      resolve: [
        {
          token: 'authenticate',
          deps: [CanAccessAppsService, Transition],
          resolveFn: (
            canAccessAppsService: CanAccessAppsService,
            transition,
          ) => {
            return canAccessAppsService.canAccessApps().then(() => {
              transition.abort();
              return transition.router.stateService.go('apps.home');
            });
          },
        },
      ],
    },
  ],
};
